require('./baseState.js');

Pegasus.ValidatingState = Pegasus.BaseState.extend({
  gotoIdle: Em.K,
  setup: function(manager){
    Pegasus.set('status', 'saving');
  },
  error: function(){
    var errorMessages = Pegasus.lookupController('header').get('errors.message'),
      targetMessage = Em.I18n.t('activerecord.errors.models.autoresponder.attributes.user.not_confirmed');

    if ( !!errorMessages ) {
      for (var i = 0; i < errorMessages.length; i++) {
        if ( errorMessages[i] === targetMessage ) {
          return;
        }
      }
    }

    Pegasus.stateMachine.transitionTo('infoGathering');
  },
  confirming: Pegasus.BaseState.extend({
    setup: function(){
      Pegasus.get('externalProxy').set('mostRecentPath', 'confirm');
      Pegasus.get('externalProxy').send('confirmRecord');
    }
  }),
  exiting: Pegasus.BaseState.extend({
    setup: function(){
      Pegasus.get('externalProxy').send('saveAndExitRecord');
    }
  }),
  previewing: Pegasus.BaseState.extend({
    setup: function(){
      Pegasus.get('externalProxy').send('previewEditorContent');
    }
  }),
  testing: Pegasus.BaseState.extend({
    setup: function(){
      Pegasus.get('externalProxy').set('mostRecentPath', 'testEmail');
      Pegasus.get('externalProxy').send('openSendTestEmailModal');
    },
    success: function(){
      Pegasus.stateMachine.transitionTo('idling');
    }
  })
});
